import styled from 'styled-components'

import SizesMap, { Sizes } from './Padding.sizes'

interface PaddingProps {
    autoWidth?: boolean
    bottom?: boolean
    center?: boolean
    disabled?: boolean
    fullHeight?: boolean
    height?: string
    hideOverflow?: boolean
    inline?: boolean
    left?: boolean
    maxHeight?: string
    noOverflow?: boolean
    noPadding?: boolean
    right?: boolean
    size?: Sizes
    top?: boolean
}

const Padding = styled.div<PaddingProps>`
    position: relative;

    ${({ autoWidth = false }) => !autoWidth && `width: 100%;`}

    ${({ inline }) => inline && `display: inline-block;`}

  ${({ fullHeight, height }) => (fullHeight ? `height: 100%;` : height && `height: ${height};`)}

  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight};`}

  ${({ noOverflow }) => noOverflow && 'overflow: auto;'}

  ${({ hideOverflow }) => hideOverflow && 'overflow: hidden;'}

  ${({ center }) => center && 'text-align: center;'}

  ${({ color }) => color && `background: ${color};`}
  
  ${({ disabled, size = Sizes.sm, top, bottom, left, right, noPadding }: PaddingProps) => {
        if (disabled) {
            return 'padding: 0; '
        }

        const { [size]: s } = SizesMap
        if (!s) {
            return
        }

        if (!(bottom || top || left || right || noPadding) || (bottom && top && left && right)) {
            return `padding: ${s}; `
        }

        let rules = ''
        if (bottom && !noPadding) {
            rules += `padding-bottom: ${s}; `
        }

        if (top && !noPadding) {
            rules += `padding-top: ${s}; `
        }

        if (left && !noPadding) {
            rules += `padding-left: ${s}; `
        }

        if (right && !noPadding) {
            rules += `padding-right: ${s}; `
        }

        return rules
    }}
`

export default Padding
